/**
 * POST /lesson-bookings/quote — what a lesson would cost this member.
 *
 * Thin pass-through: returns the envelope unchanged
 * (docs/conventions/internalapi-envelope.md). A slot that cannot be booked is a
 * 200 with `isValid: false`, not an error. Identity comes from the token.
 *
 * The payment step owns this error surface, so the transport toast and
 * transport retries are both off.
 *
 * @module lessons/api/quoteLessonBooking
 */

import { apiClient } from '~/lib/apiClient';
import type { ApiResult } from '~/lib/apiClient/types';
import type { ApiLessonBookingQuotePayload, QuoteLessonBookingRequest } from '../types';

export function quoteLessonBooking(
  body: QuoteLessonBookingRequest,
  ctx: { clubId: number; tenantHandle: string },
): Promise<ApiResult<ApiLessonBookingQuotePayload>> {
  return apiClient.post<ApiLessonBookingQuotePayload>('/lesson-bookings/quote', body, {
    clubId: ctx.clubId,
    tenantHandle: ctx.tenantHandle,
    showErrorToast: false,
    retries: 0,
  });
}
